import React from "react";
import * as accounting from "accounting";
import classNames from "classnames";

import "./AccountingJsString.scss";

interface IAccountingJsStringProps extends React.HTMLProps<HTMLSpanElement> {
  price: number;
  symbol: string;
  precision: number;
  roundUpToNearest?: number;

  /**
   * Controls order of price and symbol in resulting string
   * True: £XXX.XX
   * False: XXX.XX GBP
   */
  formatForCustomer?: boolean;
}

export class AccountingJsString extends React.Component<IAccountingJsStringProps, {}> {
  render() {
    let { symbol, roundUpToNearest, price, precision, formatForCustomer, className, ...htmlProps } = this.props;

    // Default to true to maintain compat
    formatForCustomer = formatForCustomer != null ? formatForCustomer : true;

    if (roundUpToNearest) {
      price = Math.ceil(price / roundUpToNearest) * roundUpToNearest;

      if (roundUpToNearest >= 1) {
        precision = 0;
      }
    }

    let classes = classNames(className, "money-string");
    let isNegative = price < 0;
    let priceString = accounting.formatNumber(Math.abs(price), precision); // TODO not sure of the value of accountingJS if I'm doing all this

    return formatForCustomer
      ? <span className={classes} {...htmlProps}>{isNegative && "\u2212"}<span className="symbol">{symbol}</span>{priceString}</span>
      : <span className={classes} {...htmlProps}>{isNegative && "\u2212"}{priceString}<span className="symbol"> {symbol}</span></span>
  }
}
